export const dataDesign_heading1 = [
  { key: "Client", value: "ABP Canada", name: "client" },
  { key: "Project No. ", value: "", name: "projectNo" },
  { key: "Pressure Vessel ", value: "" },
  { key: "Tag No. ", value: "" },
  { key: "Rev", value: "" },
];

export const dataDesign_heading2 = [
  {
    key: "DesignCode",
    value: "123",
    isRequired: true,
    options: ["ASME VIII DIV 1", "ASME VIII DIV 2"],
  },
  { key: "Edition ", value: "" },
  { key: "U Stamp ", value: "" },
  { key: "CRN ", value: "" },
  { key: "Units", value: "" },
];

export const dataDesign_designInputs = [
  { key: "Int. Pressure", value: "", isRequired: true },
  { key: "Ext. Pressure", value: "", isRequired: true },
  { key: "Design Temp", value: "", isRequired: true },
  { key: "MDMT", value: "", isRequired: true },
  { key: "Corr. Allow", value: "", isRequired: true },
  { key: "Joint Eff. Long", value: "", isRequired: true },
  { key: "Joint Eff. Circ", value: "", isRequired: true },
  { key: "Radiography", value: "", isRequired: true },
  { key: "Wind Speed", value: "", isRequired: true },
  { key: "Wind Design Code", value: "", isRequired: true },
  { key: "Seismic Zone", value: "" },
  { key: "Seismic Spec", value: "" },
  { key: "Impact Test", value: "" },
];

export const dataDesign_geometricParameters = [
  { key: "Orientation", value: "", isRequired: true },
  { key: "Diameter Basis", value: "", isRequired: true },
  { key: "Vessel Diameter", value: "", isRequired: true },
  { key: "Vessel Length T-T", value: "", isRequired: true },
  { key: "Vessel Length S-S", value: "", isRequired: true },
  { key: "Head Type", value: "", isRequired: true },
  { key: "Hydrotest Design", value: "", isRequired: true },
  { key: "Hydrotest Pressure", value: "" },
  { key: "Liquid Height", value: "", isRequired: true },
  { key: "Liquid Density", value: "", isRequired: true },
  { key: "Insulation Thk", value: "", isRequired: true },
  { key: "Insulation Density", value: "", isRequired: true },
  { key: "PWHT", value: "" },
];
